import {AbstractResource} from 'vue3-starter/src/typescript/resource/AbstractResource';
import {ResourceParams} from 'vue3-starter/src/typescript/resource/resource';
import {ClientIdentity, ServiceLevelType} from '@/common/api/api-raw-types';

export default class UserResource extends AbstractResource {
    identityId: string;
    companyId: string;
    firstName: string;
    admin: boolean;
    maltAdmin: boolean;
    clientIdentities: ClientIdentity[];
    serviceLevelType: ServiceLevelType;

    constructor(params: ResourceParams) {
        super(params);
        this.identityId = params.identityId;
        this.companyId = params.companyId;
        this.firstName = params.firstName;
        this.clientIdentities = params.clientIdentities;
        this.admin = params.admin;
        this.maltAdmin = params.maltAdmin;
        this.serviceLevelType = params.serviceLevelType;
    }

    get currentIdentity(): ClientIdentity | null {
        return this.clientIdentities.find((identity) => identity.companyId === this.companyId) || null;
    }
}
